import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import * as S from "./BodyModalChat.Style";
import { ReactComponent as Arrow } from "../../../assets/images/chat/arrow-complete-icon.svg";
import { ReactComponent as ArrowReverse } from "../../../assets/images/chat/arrow-reverse-icon.svg";
import BodyOptions from "./BodyOptions";
import useWindowSize from "../../../hooks/useWindowSize";
import { applyKey } from "../../../utils";
import * as Chat from "../../../config";

const BodyModalChat = ({ itemChat, showModal, activeItem, setActiveItem }) => {
  const { width } = useWindowSize()
  const isDesktop = width > 768

  useEffect(() => {
    if (!showModal) setActiveItem(null);
  }, [setActiveItem, showModal]);

  const renderSpacingLine = () => isDesktop ? <><br /><br /></> : null;

  const INSURANCE_TYPES = {
    HABITACIONAL: "Seguro Habitacional",
    EMPRESARIAL: "Seguro Empresarial",
    RESIDENCIAL: "Seguro Residencial",
  };

  const TitleTopics = {
    Sinistro: "Sinistro",
    Servicos: "Serviços",
    Assistencias: "Assistências",
  }

  const phrases = {
    FromMondayToFriday: "Segunda a sexta, de 8h às 21h. Sábados, domingos e feriados, das 9h às 17h."
  }

  const descriptions = {
    [INSURANCE_TYPES.HABITACIONAL]: [
      {
        title: TitleTopics.Servicos,
        chatId: Chat.chatIdHabitacionalServicos,
        description: (
          <>
            Dúvidas sobre o seguro, 2ª via de certificado, condições gerais, entre outros.
            {renderSpacingLine()}
            {phrases.FromMondayToFriday}
          </>
        )
      },
      {
        title: TitleTopics.Sinistro,
        chatId: Chat.chatIdHabitacionalSinistro,
        description: (
          <>
            Danos ao seu lar, causados por desastres naturais ou outros eventos cobertos pelo seu
            seguro e especificados na sua apólice e em casos de falecimento ou invalidez permanente.
            {renderSpacingLine()}
            De segunda a sexta, exceto feriados nacionais, das 8h às 18h.
          </>
        )
      },
      {
        title: TitleTopics.Assistencias,
        chatId: Chat.chatIdHabitacionalAssistencias,
        description: (
          <>
            Serviços como chaveiro, eletricista e encanador para resolver acontecimentos previstos
            ou emergenciais do dia a dia, de acordo com as coberturas e assistências contratadas e
            especificadas na sua apólice de seguro.
            {renderSpacingLine()}
            24 horas por dia, todos os dias da semana, incluindo feriados nacionais.
          </>
        )
      }
    ],
    [INSURANCE_TYPES.EMPRESARIAL]: [
      {
        title: TitleTopics.Servicos,
        chatId: Chat.chatIdEmpresarialServicos,
        description: (
          <>
            Informações gerais, alteração ou renovação do seguro, 2ª via de boletos e documentos, cancelamento, entre outros.
            {renderSpacingLine()}
            {phrases.FromMondayToFriday}
          </>
        )
      },
      {
        title: TitleTopics.Sinistro,
        chatId: Chat.chatIdEmpresarialSinistro,
        description: (
          <>
            Danos à empresa, causados por desastres naturais ou outros eventos cobertos pelo seu seguro e especificados na sua apólice.
            {renderSpacingLine()}
            De segunda a sexta, exceto feriados nacionais, das 8h às 19h.
          </>
        )
      },
      {
        title: TitleTopics.Assistencias,
        chatId: Chat.chatIdEmpresarialAssistencias,
        description: (
          <>
            Serviços como chaveiro, eletricista e encanador que ajudam você a resolver imprevistos durante a sua rotina no trabalho.
            {renderSpacingLine()}
            24 horas por dia, todos os dias da semana, inclusive feriados nacionais.
          </>
        )
      }
    ],
    [INSURANCE_TYPES.RESIDENCIAL]: [
      {
        title: TitleTopics.Servicos,
        chatId: Chat.chatIdResidencialServicos,
        description: (
          <>
            Informações gerais ou alteração do seguro, 2ª via de boletos e documentos, cancelamento, entre outros.
            {renderSpacingLine()}
            {phrases.FromMondayToFriday}
          </>
        )
      },
      {
        title: TitleTopics.Sinistro,
        chatId: Chat.chatIdResidencialSinistro,
        description: (
          <>
            Danos ao seu lar, causados por desastres naturais ou outros eventos cobertos pelo seu seguro e especificados na sua apólice.
            {renderSpacingLine()}
            De segunda a sexta, exceto feriados nacionais, das 8h às 19h.
          </>
        )
      },
      {
        title: TitleTopics.Assistencias,
        chatId: Chat.chatIdResidencialAssistencias,
        description: (
          <>
            Serviços como chaveiro, eletricista e encanador que ajudam você a resolver imprevistos durante o seu dia a dia.
            {renderSpacingLine()}
            24 horas por dia, todos os dias da semana, inclusive feriados nacionais.
          </>
        )
      }
    ]
  };

  const renderBodyOptions = (type) => {
    return (
      <S.ContainerBodyOptions>
        {descriptions[type].map(({ title, description, chatId }) => (
          <BodyOptions
            key={title}
            titleOption={title}
            DescriptionOption={description}
            chatId={chatId}
          />
        ))}
      </S.ContainerBodyOptions>
    )
  }

  return (
    <>
      {!activeItem && (
        <>
          {applyKey(itemChat, ({ label, icon }) => (
            <S.ModalChatContent key={label} type="button">
              <S.ModalChatItem
                onClick={() => setActiveItem(label)}
                visible={showModal}
                textSize="sm"
              >
                <S.ModalChatIconWithTitle>
                  {icon}
                  <S.ModalChatTitle>{label}</S.ModalChatTitle>
                </S.ModalChatIconWithTitle>
                <Arrow />
              </S.ModalChatItem>
              {itemChat.at(-1).label !== label && <S.ModalChatDivider />}
            </S.ModalChatContent>
          ))}
        </>
      )}
      {activeItem && (
        <>
          <S.ModalChatIconWithTitle margin>
            {itemChat.find(item => item.label === activeItem).icon}
            <S.ModalChatTitle>{activeItem}</S.ModalChatTitle>
          </S.ModalChatIconWithTitle>
          <S.DescriptionForOptionsModal>Escolha o assunto que quer falar e se atente aos horários de atendimento.</S.DescriptionForOptionsModal>
          {renderBodyOptions(activeItem)}
          <S.BackButton onClick={() => setActiveItem(null)}><ArrowReverse />Voltar</S.BackButton>
        </>
      )
      }
    </>
  );
};

BodyModalChat.propTypes = {
  itemChat: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.element.isRequired,
    })
  ).isRequired,
  showModal: PropTypes.bool.isRequired,
  activeItem: PropTypes.string,
  setActiveItem: PropTypes.func.isRequired,
};

BodyModalChat.defaultProps = {
  activeItem: null
};

export default BodyModalChat;
